"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withRouter = exports.useRouter = exports.Router = void 0;
const tslib_1 = require("tslib");
const router_1 = tslib_1.__importStar(require("next/router"));
exports.Router = router_1.default;
exports.useRouter = router_1.useRouter;
exports.withRouter = router_1.withRouter;
//# sourceMappingURL=useRouter.js.map